export enum CreateRoomType {
  TextRoom = 'text',
  VoiceRoom = 'voice',
  ForumRoom = 'forum',
}

export enum CreateRoomAccess {
  Private = 'private',
  Restricted = 'restricted',
  Public = 'public',
}
